function lazyLoadBackgrounds(selector){
    // Check for IntersectionObserver support
    if ('IntersectionObserver' in window) {

        function handleIntersection(entries) {
          entries.map((entry) => {
            if (entry.isIntersecting) {
              // Item has crossed our observation
              // threshold - load src from data-src
              entry.target.style.backgroundImage = "url('"+entry.target.dataset.bgimage+"')";
              // Job done for this item - no need to watch it!
              observer.unobserve(entry.target);
            }
          });
        }
  
        const items = document.querySelectorAll(selector);

        const observer = new IntersectionObserver(
          handleIntersection,
          { rootMargin: "100px" }
        );

        items.forEach(item => observer.observe(item));
    } else {
      // No interaction support? Load all background images automatically
      const items = document.querySelectorAll(selector);
      items.forEach(item => {
        item.style.backgroundImage = "url('"+item.dataset.bgimage+"')";
      });
    }
  }

  export {
    lazyLoadBackgrounds
  }
  